import React from "react";
import { Button } from "@/components/ui/button";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const currentMode = isDark ? "الليلي" : "النهاري";
  const nextMode = isDark ? "النهاري" : "الليلي";

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggle}
      className={`h-9 gap-1.5 px-2 text-xs font-semibold ${
        isDark
          ? "border-sky-300/50 bg-slate-800 text-sky-100 hover:bg-slate-700"
          : "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100"
      }`}
      data-testid="theme-toggle"
      aria-label={`الوضع ${currentMode} مفعل؛ اضغط للتبديل إلى الوضع ${nextMode}`}
      aria-pressed={isDark}
      title={`التبديل إلى الوضع ${nextMode}`}
    >
      {isDark ? <Moon className="h-4 w-4" aria-hidden="true" /> : <Sun className="h-4 w-4" aria-hidden="true" />}
      <span>وضع {currentMode}</span>
    </Button>
  );
}
